module.exports = __webpack_public_path__ + "static/1- NSP-a0fc41500bcf3960eab1790d1937195c.png";